import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { downgradeComponent } from '@angular/upgrade/static';
import { Store } from '@ngrx/store';
import { DOCUMENT } from '@angular/common';
import { Subscription } from 'rxjs';
import { AppState } from './store';
import { closeShortcutsModal, openShortcutsModal } from './common/store/app-common.actions';
import { selectIsShortcutsModalOpenFlag } from './common/store/app-common.selectors';
import { ShortcutsService } from './package-designer/services/shortcuts.service';
import { closeAllModals } from './account/store/account.actions';

@Component({
  selector: 'app',
  template: `
    <ngx-loading-bar [includeSpinner]="false"></ngx-loading-bar>
    <xp-modal
      [isOpen]="isShortcutsModalOpen$ | async"
      [closeButtonText]="'app.controller.modals.shortcuts.actions.close' | translate"
      [saveButtonText]="'package.generic-object.buttons.save' | translate"
      [titleText]="'app.controller.modals.shortcuts.actions.title' | translate"
      (close)="onShortcutsModalClose()"
      [isSmall]="true"
    >
      <ng-template>
        <xp-shortcuts></xp-shortcuts>
      </ng-template>
    </xp-modal>
  `,
})
export class AppComponent implements OnInit, OnDestroy {
  isShortcutsModalOpen$ = this.store.select(selectIsShortcutsModalOpenFlag);

  shortcutsSubscriptions: Subscription[] = [];
  pressedKeys: any = {};

  constructor(
    private store: Store<AppState>,
    private shortcutsService: ShortcutsService,
    @Inject('$rootScope') private $rootScope: any,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngOnInit() {
    this.shortcutsSubscriptions = [
      this.shortcutsService.addShortcut({ shouldPreventInInput: true, keys: 'shift.?' }).subscribe(() => {
        this.store.dispatch(openShortcutsModal());
      }),
      this.shortcutsService.addShortcut({ shouldPreventInInput: true, keys: 'meta./' }).subscribe(() => {
        this.store.dispatch(openShortcutsModal());
      }),
    ];

    this.document.addEventListener('keydown', this.keyDownListener.bind(this));
    this.document.addEventListener('keyup', this.keyUpListener.bind(this));
  }

  onShortcutsModalClose() {
    this.store.dispatch(closeShortcutsModal());
  }

  keyDownListener(e: KeyboardEvent) {
    this.pressedKeys[e.key] = true;

    if ((e.target as HTMLElement).tagName === 'INPUT') {
      return;
    }

    if (this.pressedKeys.g && e.key === 'i') {
      this.$rootScope.stateGo('app.account.connections');
    }

    if (this.pressedKeys.g && e.key === 'p') {
      this.$rootScope.stateGo('app.account.packages');
    }

    if (this.pressedKeys.g && e.key === 'j') {
      this.$rootScope.stateGo('app.account.jobs');
    }

    if (this.pressedKeys.g && e.key === 'c') {
      this.$rootScope.stateGo('app.account.clusters');
    }

    if (this.pressedKeys.g && e.key === 's') {
      this.$rootScope.stateGo('app.account.schedules');
    }

    if (e.key === 'Escape') {
      this.store.dispatch(closeAllModals());
    }
  }

  keyUpListener(e: KeyboardEvent) {
    this.pressedKeys[e.key] = false;
  }

  ngOnDestroy() {
    this.shortcutsSubscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
    this.document.removeEventListener('keydown', this.keyDownListener.bind(this));
    this.document.removeEventListener('keyup', this.keyUpListener.bind(this));
  }
}

((window as any).xplenty as angular.IModule).directive(
  'appComponent',
  downgradeComponent({
    component: AppComponent,
  }),
);
